import * as React from 'react';
import { baseApiRoute } from 'src/resources/const';
import ImageGallery from 'react-image-gallery';
import '../../UpdateProject.css';
import ReactDropzone, { ImageFile } from 'react-dropzone';
import ProjectData from 'src/value-objects/ProjectData';
import RichEditContainer from 'src/modules/commons/inputs/rich-edit/RichEdit.container';

export interface ProjectSummaryFormComponentProps {
  formData: ProjectData;
  handleChange: (key: string) => (value: string | File | boolean) => void;
  handleRichEditor: (key: string) => (html: string) => void;
}

class ProjectSummaryFormComponent extends React.Component<ProjectSummaryFormComponentProps> {

  public render(): React.ReactNode {

    let items = this.props.formData.images.map((image) => (
      {
        original: image.encoded ? image.url : baseApiRoute + image.url,
        originalClass: 'project-summary-photo',
        thumbnail: image.encoded ? image.url : baseApiRoute + image.url
      }
    ));

    return (

      <div>
        <p className="f-s-26">
          Resumen de la empresa
        </p>
        <div className="gap-20"/>
        <div className="row">
          <div className="col-md-9">
          <RichEditContainer
            onChange={(value) => this.props.handleRichEditor('description')(value)}
            placeholder="Añade tu resumen"
            uploadURL={baseApiRoute + '/save-image'}
            value={this.props.formData.description}
          />
          </div>
          <div className="col-md-3">
            {items.length > 0 ?
              <div>
                <ImageGallery
                  items={items}
                  showThumbnails={true}
                  showPlayButton={false}
                  showFullscreenButton={false}
                />
                <ReactDropzone
                  className="project-summary-dropzone text-center pointer"
                  onDrop={(files: ImageFile[]) => {
                    files.forEach(file => {
                      this.props.handleChange('projectImages')(file);
                    });
                  }}
                  multiple={true}
                  accept="image/*"
                >
                  <span className="add-more-img"/>
                  <p className="text-center">
                    Añadir una nueva imagen
                  </p>
                </ReactDropzone>
              </div>
              :
              <div>
                <ReactDropzone
                  className="text-center pointer"
                  onDrop={(files: ImageFile[]) => {
                    files.forEach(file => {
                      this.props.handleChange('projectImages')(file);
                    });
                  }}
                  multiple={true}
                  accept="image/*"
                >
                  <span className="add-more-img"/>
                  <p className="text-center">
                    Añadir una imagen
                  </p>
                </ReactDropzone>
              </div>
            }
            <div className="gap-20"/>
            {
              // TODO
            }
            {/*<p className="c-grey f-s-12">Selecciona la imagen que se mostrará en primer lugar</p>*/}
          </div>
        </div>
        <div className="gap-20"/>
      </div>
    );
  }
}

export default ProjectSummaryFormComponent;



// WEBPACK FOOTER //
// ./src/modules/project/update/partials/round-information/ProjectSummaryForm.component.tsx